const paymentHistory = (state = null, action) => {
  const { payload, type } = action;

  switch (type) {
    case 'SET_PAYMENT_HISTORY':
      return payload;

    case 'LOGOUT':
      return null;

    default:
      return state;
  }
};

export default paymentHistory;
